import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Router, RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LoadingBar } from '@layout/ui/loading-bar';
import { AccountService } from '@core/auth';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingBar, TranslocoModule, MatButton],
  host: {
    // Ensure root component fills the entire viewport
    class: 'flex min-h-full w-full flex-auto flex-col',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@if (!production) {
      <div
        class="pointer-events-none fixed top-0 left-0 z-50 rounded-br bg-amber-9 px-2 py-0.5 font-mono text-xs font-bold text-black print:hidden"
      >
        DEV
      </div>
    }
    <loading-bar [active]="isLoading()" />
    @if (accountService.accountResource.error()) {
      <div
        class="absolute top-0 right-0 bottom-0 left-0 z-50 flex flex-col items-center justify-center bg-white"
        *transloco="let t"
      >
        <img
          class="mb-4 h-25 px-6"
          src="logo.svg"
          alt="logo"
        />
        <div class="my-3 text-center text-error">
          {{ t('SENTENCES.AN_ERROR_OCCURRED') }}
        </div>
        <div class="flex flex-row justify-center">
          <button
            matButton
            (click)="accountService.accountResource.reload()"
          >
            {{ t('SENTENCES.TRY_AGAIN') }}
          </button>
        </div>
      </div>
    } @else if (!accountService.accountResource.isLoading()) {
      <router-outlet />
    }`,
})
export class App {
  protected readonly accountService = inject(AccountService);
  protected readonly router = inject(Router);
  protected readonly production = environment.production;

  protected readonly isLoading = computed(
    () =>
      this.accountService.accountResource.isLoading() ||
      (!this.accountService.accountResource.error() &&
        this.router.currentNavigation() != null)
  );

  constructor() {
    if (!this.production) document.title = `[DEV] ${document.title}`;
  }
}
